import { ButtonPrimeReact, Checkbox, SearchInput } from "@finanedi.es/storybook"
import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { List, ListItem } from "./useFilteredList"

interface FilteredListProps<T> {
  filteredList: List<T> | undefined
  itemsSelected: List<T> | undefined
  searchItem: string | undefined
  label: keyof T
  setItemsSelected: (value: List<UsuarioReadingFiltersDtoProps>) => void
  onSearchItem: (value: string) => void
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function FilteredList<T extends { id?: $TSMigrationFixMe }>({
  filteredList,
  itemsSelected,
  searchItem,
  label,
  setItemsSelected,
  onSearchItem,
}: FilteredListProps<T>) {
  const { t } = useTranslation()
  const handleOnClick = (item: ListItem<UsuarioReadingFiltersDtoProps>) => {
    const newItemSelected = itemsSelected?.some(
      (selectedItem: ListItem<UsuarioReadingFiltersDtoProps>) =>
        selectedItem.id === item.id
    )
      ? itemsSelected?.filter(
          (selectedItem: ListItem<UsuarioReadingFiltersDtoProps>) =>
            selectedItem.id !== item.id
        )
      : [...(itemsSelected || []), { id: item?.id, nombre: item?.nombre }]
    setItemsSelected(newItemSelected)
  }
  const DEFAULT_LIST_LENGTH = 4
  const [listLength, setListLength] = useState<number | undefined>(
    DEFAULT_LIST_LENGTH
  )

  return (
    <>
      <SearchInput
        placeholder={`${t("filtros.contactos.placeholderSearch")}`}
        onChange={(ev: string) => {
          onSearchItem(ev)
        }}
        inputValue={searchItem}
        className='tw-h-10 tw-w-full tw-mb-3'
      />
      {filteredList?.slice(0, listLength)?.map((item: ListItem<T>) => (
        <div
          key={item.id}
          className='tw-mb-2 tw-flex hover:!tw-bg-gray-100 tw-p-1 tw-rounded-md tw-cursor-pointer tw-transition-colors tw-duration-300 tw-ease-in-out tw-items-center'
          onClick={() => handleOnClick(item)}
        >
          <Checkbox
            key={item.id}
            id={item && typeof item === "object" ? item?.id : String(item)}
            isChecked={Boolean(
              itemsSelected?.some(
                (itemSelect: ListItem<T>) => itemSelect.id === item.id
              )
            )}
          />
          <p className='tw-my-auto tw-ml-2 tw-truncate !tw-lowercase first-line:!tw-capitalize'>
            {item[label] as string}
          </p>
        </div>
      ))}
      {filteredList && filteredList?.length > DEFAULT_LIST_LENGTH && (
        <ButtonPrimeReact
          className='tw-w-full tw-cursor-pointer !tw-bg-white !tw-text-info hover:!tw-bg-info-10 !tw-border-none tw-rounded-md tw-py-1 tw-px-2'
          label={
            listLength
              ? `${t("empresasGestionadas.filterMenu.seeMore")}`
              : `${t("empresasGestionadas.filterMenu.seeLess")}`
          }
          onClick={() =>
            setListLength(listLength ? undefined : DEFAULT_LIST_LENGTH)
          }
        />
      )}
    </>
  )
}
